import React from 'react';
import Wave from 'react-wavify';
import styled from 'styled-components';

export const WaveSeparatorGalerieAndContactContainer = styled.div`

  background-color: ${({ theme }) => theme.colors.galerieSectionBackground};
`;
function WaveSeparatorGalerieAndContact( {theme, darkMode }) {
  return (
  
    <div style={{ position: 'relative', top: '20px', backgroundColor: 'transparent' }}>
      <Wave
         fill={darkMode ? theme.colors.contactSectionBackground : theme.colors.contactSectionBackground}
        paused={false}
        options={{
          height: 20,
          amplitude: 10,
          speed: 0.2,
          points: 4,
          wavelength: 100,
       
          

          
        }}
      />
  
  </div>
  
  );
}

export default WaveSeparatorGalerieAndContact;